/* =========================================================================
   PM BEAUTY STUDIO — contenido editable de la home
   Este es el ÚNICO archivo que Paola necesita tocar para cambiar textos,
   ofertas, precios o preguntas frecuentes. No hay que tocar JSX.
   ========================================================================= */

/* ---------- Datos del negocio (verificados en el sitio actual) ---------- */
export const BUSINESS = {
  name: 'PM Beauty Studio',
  legacyName: 'PaoMakeup Beauty Studio', // solo para SEO (alternateName)
  address: 'Calle Juan Isidro Ortega #302, Los Prados, Santo Domingo, D.N.',
  mapsUrl: 'https://www.google.com/maps/place/PM+Beauty+Studio+by+PaoMakeup+-+Centro+de+Belleza+y+Maquillaje/@18.4785111,-69.9610913,17z/data=!4m8!3m7!1s0x8eaf89e0c6ea0b27:0xff4331c1f6c975f1',
  hours: 'Lunes a sábado, de 9:00 a.m. a 7:00 p.m.',
  hoursShort: 'Lun a sáb · 9:00 a.m. – 7:00 p.m.',
  parking: 'Parqueo siempre disponible',
  geo: { lat: 18.4785111, lng: -69.9610913 },
  phone1: '809-547-4779',
  phone1Tel: '+18095474779',
  phone2: '829-729-4779',
  phone2Tel: '+18297294779',
  email: 'info@paomakeup.com',
  logo: '/assets/paomakeup/images/pm-logo-160.png',
  logo2x: '/assets/paomakeup/images/pm-logo-320.png',
  youtubeId: '1czcqWGixZ4',
};

/* WhatsApp: número y texto tomados del botón flotante que ya existe en el sitio.
   OJO: el número correcto es el 829-729-4779, no el 809. */
export const WHATSAPP =
  'https://api.whatsapp.com/send?phone=18297294779' +
  '&text=' + encodeURIComponent('Hola! Quisiera más información sobre los servicios de ...');

export const SOCIAL = {
  facebook: 'https://www.facebook.com/PaoMakeupBeautyStudio/',
  instagram: 'https://www.instagram.com/pmbeautystudio.rd',
  youtube: 'https://www.youtube.com/channel/UCLzJpdrplA9Oy6K1tVf8ZHw',
  // El sitio actual apunta a tiktok.com/paomakeup (sin @) y no resuelve.
  // Este es el usuario correcto, confirmado por el cliente.
  tiktok: 'https://www.tiktok.com/@pmbeautystudio.rd',
};

/* ---------- Rutas ---------- */
export const ROUTES = {
  home: '/',
  nosotros: '/nosotros',
  servicios: '/nuestros-servicios',
  precios: '/nuestros-servicios/precios',
  agendar: '/agendar-cita',
  login: '/iniciar-sesion',
  cotizar: '/cotiza-tu-evento',
  evaluacion: '/evaluacion-para-maquillaje-semipermanente',
};

/* ---------- Hero ---------- */
export const HERO_SLIDES = [
  {
    src: '/assets/paomakeup/images/services/microblading.jpg',
    alt: 'Detalle de cejas con maquillaje semipermanente y acabado natural',
    caption: 'Maquillaje semipermanente y microblading',
    w: 1080, h: 1080,
  },
  {
    src: '/assets/paomakeup/images/services/maquillaje-cliente.jpg',
    alt: 'Clienta con maquillaje profesional terminado en el estudio',
    caption: 'Maquillaje para eventos, con pestañas incluidas',
    w: 932, h: 1080,
  },
  {
    src: '/assets/paomakeup/images/services/pestanas.jpg',
    alt: 'Extensiones de pestañas aplicadas una a una',
    caption: 'Extensiones de pestañas, del efecto natural al glam',
    w: 1083, h: 1080,
  },
  {
    src: '/assets/paomakeup/images/services/salon-belleza.jpg',
    alt: 'Interior del salón de belleza PM Beauty Studio',
    caption: 'Salón completo: color, corte y tratamientos',
    w: 1082, h: 1080,
  },
  {
    src: '/assets/paomakeup/images/services/service-beauty-nails.jpg',
    alt: 'Manicure terminado con acabado impecable',
    caption: 'Manicure y pedicure',
    w: 847, h: 562,
  },
];

/* ---------- Servicios ----------
   Los `slug` están verificados contra la API real:
   https://agendamax.do/api/v1/businesses/4/categories

   Precios reales de la API (mínimo–máximo) para que Paola decida cuál mostrar.
   Solo se muestran los dos que NO se prestan a confusión; los demás tienen el
   mínimo tan bajo porque incluyen complementos sueltos (ej. retirar esmalte).

     maquillaje-semi-permanente  RD$  3,000 – 15,000   (9 servicios)
     maquillajes                 RD$    500 –  6,000   (25 servicios)
     membresias                  RD$  2,500 –  4,500   (3 servicios)
     cejas-pestanas              RD$    500 –  6,000   (55 servicios)
     cuidado-de-la-piel          RD$    500 –  6,000   (25 servicios)
     unas                        RD$     75 –  2,500   (53 servicios)
     peluqueria                  RD$    200 – 18,000   (71 servicios)

   Para mostrar un "desde", poner el texto en `priceFrom`. Si es null, no se
   renderiza el chip. */
export const SERVICES = [
  {
    slug: 'maquillaje-semi-permanente',
    title: 'Maquillaje semipermanente',
    badge: 'Nuestra especialidad',
    text: 'Microblading, hair stroke, delineado y labios. Despiertas lista, sin retocarte cada mañana.',
    image: '/assets/paomakeup/images/services/microblading.jpg',
    imageAlt: 'Cejas con microblading y acabado natural',
    w: 1080, h: 1080,
    priceFrom: 'Desde RD$ 3,000',
    fact: 'Evaluación gratis',
  },
  {
    slug: 'maquillajes',
    title: 'Maquillajes',
    badge: 'Incluye pestañas',
    text: 'Todos nuestros maquillajes incluyen aplicación de pestañas para un acabado completo y elegante.',
    image: 'https://agendamax.do/storage/service-categories/EIK21rvSm5mPADjeyuo3pc8bgQz5hI6D4znbSLVj.jpg',
    imageAlt: 'Maquillaje profesional aplicado en el estudio',
    w: 800, h: 1200,
    priceFrom: null,
    fact: 'Social · Novias · Eventos',
  },
  {
    slug: 'membresias',
    title: 'Membresías',
    badge: 'Ahorra todo el año',
    text: 'Ahorra y disfruta de tus servicios favoritos con beneficios exclusivos, atención preferencial y una experiencia diseñada para ti.',
    image: null, // la categoría no tiene imagen en AgendaMax: se usa un placeholder de marca
    imageAlt: '',
    priceFrom: 'Desde RD$ 2,500',
    fact: 'Atención preferencial',
  },
  {
    slug: 'cejas-pestanas',
    title: 'Cejas y pestañas',
    badge: 'Más solicitado',
    text: 'Diseñamos y realzamos tu mirada con un acabado natural, armonioso y acorde a tus facciones.',
    image: 'https://agendamax.do/storage/service-categories/U21hJPy7lKKPZd9G8hdX53bz5ZSY0kPJV6RzhFPj.jpg',
    imageAlt: 'Diseño de cejas y extensiones de pestañas',
    w: 800, h: 794,
    priceFrom: null,
    fact: 'Lifting · Extensiones',
  },
  {
    slug: 'cuidado-de-la-piel',
    title: 'Cuidado de la piel',
    badge: 'Exclusivo por cita',
    text: 'Tratamientos faciales y corporales para limpiar, hidratar y revitalizar. También depilación con cera. Esta área se atiende exclusivamente con cita.',
    image: 'https://agendamax.do/storage/service-categories/xZ0slwb3OPrwC43xyufS1G0UVNg8XOKnnlKswlV0.jpg',
    imageAlt: 'Tratamiento facial de limpieza e hidratación',
    w: 1274, h: 1314,
    priceFrom: null,
    fact: 'Faciales · Depilación',
  },
  {
    slug: 'unas',
    title: 'Uñas',
    badge: null,
    text: 'Manicure y pedicure con acabados impecables que combinan belleza, higiene y durabilidad.',
    image: 'https://agendamax.do/storage/service-categories/Wuo0anug3ZSpb2F6eW8D97FclXQEjqjHY5aEfYG1.jpg',
    imageAlt: 'Manicure con acabado impecable',
    w: 847, h: 562,
    priceFrom: null,
    fact: 'Manicure · Pedicure',
  },
  {
    slug: 'peluqueria',
    title: 'Peluquería',
    badge: null,
    text: 'Corte, color, peinados y tratamientos capilares para mantener tu cabello saludable y adaptado a tu estilo.',
    image: 'https://agendamax.do/storage/service-categories/bxvLZ1Zu85j6KvMlEU3p1Ywoa9WkLR0l9IsrmfUx.jpg',
    imageAlt: 'Servicio de peluquería: corte, color y tratamiento capilar',
    w: 1200, h: 800,
    priceFrom: null,
    fact: 'Color · Tratamientos',
  },
];

export const serviceUrl = (slug) => `/nuestros-servicios/${slug}/precios`;

/* ---------- Ofertas del mes ----------
   Las ofertas vienen COMPLETAS del backend:
     https://agendamax.do/api/v1/businesses/4/promotions
   La home muestra solo el arte del flyer de cada promoción vigente con un CTA
   de reserva encima; todo el contenido (combos, precios, condiciones) vive en
   la imagen que el negocio sube a AgendaMax. Aquí no se mantiene nada. */

/* ---------- Reseñas ----------
   REALES. Transcritas literalmente del perfil de Google Business del studio
   (ficha "PM Beauty Studio by PaoMakeup - Centro de Belleza y Maquillaje").
   Las 8 leídas eran de 5 estrellas; aquí van 6.

   No se corrigió la ortografía: se citan tal cual las escribió la clienta.
   El "…" al final indica que la reseña original es más larga.

   El campo `service` NO viene de Google: se dedujo de lo que menciona cada
   texto. Si prefieren no interpretarlo, poner null y no se muestra.

   Recomendación: migrar esto a la Google Places API para que se actualice
   solo. Ver LEEME-INSTRUCCIONES.md. */
export const GOOGLE_PLACE_URL =
  'https://www.google.com/maps/place/PM+Beauty+Studio+by+PaoMakeup+-+Centro+de+Belleza+y+Maquillaje/' +
  '@18.4785111,-69.9610913,17z/data=!4m8!3m7!1s0x8eaf89e0c6ea0b27:0xff4331c1f6c975f1';

export const REVIEWS = [
  {
    name: 'Krysbel T', rating: 5, service: 'Uñas, pelo, pestañas y pedicure',
    text: 'Todo estuvo espectacular. Me hice las uñas, el pelo, las pestañas y los pies, y de verdad que nunca había vivido una experiencia tan perfecta como en PaoMakeup, ni siquiera en los Estados Unidos. Todo quedó hermoso y el servicio fue de primera. 100% recomendado.',
  },
  {
    name: 'Lucy Martínez', rating: 5, service: 'Peluquería · Local Guide',
    text: 'Hoy pasamos un día muy agradable en en salón, desde q llegamos nos recibieron como princesas, desde el momento que agendas tu cita te dan seguimiento y se preocupen por lo que quieres lograr, asesorandote, que sea saludable para tu pelo…',
  },
  {
    name: 'camila cabrera', rating: 5, service: 'Peluquería',
    text: 'Excelente servicio de Ada y Yolanda, siempre a la orden. Cabe destacar con mucho mérito a Emilia, excelente estilista y profesional, guía tu cabello en un proceso de principio a fin.',
  },
  {
    name: 'santa sanchez', rating: 5, service: 'Pedicure',
    text: 'Excelente servicio de pedicure con Leonor. Quedé muy satisfecha con la atención; se nota el cuidado y el detalle que pone en cada etapa del proceso. Un trabajo muy delicado y lindo, totalmente recomendada.',
  },
  {
    name: 'Leibnitz Novas', rating: 5, service: 'Reseña de Google',
    text: 'Altamente agradecida del trabajo realizado. El equipo de Pao Makeup brindan una experiencia y sobretodo un resultado extraordinario. 100% recomendado.',
  },
  {
    name: 'Scarlet Valenzuela', rating: 5, service: 'Manicure',
    text: 'Excelente servicio de Andreina! Muy atenta y cuidadosa con el manejo de las manos.',
  },
];

/* ---------- Métricas ----------
   Poner null en lo que no esté confirmado: el componente muestra "—".
   Los dos primeros son datos reales del sistema (endpoint del negocio):
   employees_count = 15, services_count = 261. */
export const GOOGLE_RATING = { value: '4,9', count: 148 };

export const STATS = [
  { value: '4,9', star: true, label: '148 reseñas en Google' },
  { value: '15', label: 'Profesionales en el equipo' },
  { value: '261', label: 'Servicios en carta' },
  { value: '7', label: 'Categorías de servicio' },
];

/* ---------- FAQ ----------
   Las marcadas con `pending: true` llevan una nota de "por confirmar" en el
   texto. Quitar la nota cuando Paola dé el dato real. */
export const FAQS = [
  {
    q: '¿El microblading duele?',
    a: 'Es la pregunta que más nos hacen. En la evaluación gratuita te explicamos con detalle cómo se siente el procedimiento, qué usamos para tu comodidad durante la sesión y qué esperar los días siguientes. Sin compromiso de agendar.',
    pending: false,
  },
  {
    q: '¿Cuánto dura el maquillaje semipermanente?',
    a: 'Depende de tu tipo de piel, la exposición al sol y el cuidado posterior. En la evaluación gratuita te damos el estimado para tu caso y cuándo tocaría el retoque.',
    pending: false,
  },
  {
    q: '¿Necesito cita o puedo llegar directamente?',
    a: 'Abrimos de lunes a sábado, de 9:00 a.m. a 7:00 p.m., y hay parqueo siempre disponible. Recomendamos agendar: garantiza tu horario y evita esperas. El área de Cuidado de la Piel se atiende exclusivamente con cita. Los miércoles, la promoción de cejas se atiende por orden de llegada.',
    pending: false,
  },
  {
    // Dato real: aparece al pie de las dos promociones vigentes.
    q: '¿Qué formas de pago aceptan?',
    a: 'Tarjeta, transferencia bancaria y efectivo.',
    pending: false,
  },
  /* PENDIENTE — política de cancelación.
     Se deja fuera a propósito: publicar una FAQ que dice "por confirmar" es
     peor que no tenerla. Descomentar cuando el studio defina con cuántas horas
     de antelación se puede cancelar y si hay penalidad. Una política clara
     sube las reservas porque baja el riesgo percibido.

  {
    q: '¿Puedo cancelar o reprogramar mi cita?',
    a: 'Sí, avisando con XX horas de antelación y sin penalidad.',
    pending: false,
  },
  */
  {
    q: '¿Atienden novias y eventos fuera del estudio?',
    a: 'Sí, el estudio ofrece cotización para eventos. Escríbenos con la fecha, la cantidad de personas y el lugar, y te preparamos una propuesta.',
    pending: false,
  },
];
